import React from 'react';

import { SortMethods } from '../../../../../../shared/hooks/useSort';
import { GridTableRow } from '../../../../../../shared/components/table-components';
import { SortButtons } from '../../../../../../shared/components/buttons';

type SchoolHeaderRowProps = {
  sortMethods: SortMethods<'name' | 'amountOfCustomers'>;
};

const SchoolHeaderRow = ({ sortMethods }: SchoolHeaderRowProps) => {
  const { getIsSortedBy, handleSort } = sortMethods;

  return (
    <GridTableRow variant="header">
      <SortButtons fieldName="name" onSort={handleSort} getIsActive={getIsSortedBy}>
        Name
      </SortButtons>
      <SortButtons
        fieldName="amountOfCustomers"
        onSort={handleSort}
        getIsActive={getIsSortedBy}
      >
        Amount Of Customers
      </SortButtons>
    </GridTableRow>
  );
};

export { SchoolHeaderRow };
